import { combineReducers } from 'redux';
import { editCostCenter } from 'modules/settings/submodules/clients/costCenters/components/EditCostCenter/store/reducer';
import { costCenterFilter } from 'modules/settings/submodules/clients/costCenters/components/Filter/store/reducer';

export const costCenters = combineReducers({
    editCostCenter,
    costCenterFilter,
});
